import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.403 8 6.114 14.065.05A57 57 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017q-.013-.923.027-1.898L6.114 8 2.467 4.353a9 9 0 0 1 1.821-1.95",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031Q15.276.007 16 0L8.472 7.529l-.708-.708zM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772M.003 16v-.003L7.53 8.47l.707.708L1.414 16zm8.469-7.529.707-.707L16 14.586V16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372q.168-.075.342-.143C7.272.876 8.544.6 10 .4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442q.172-1.061.424-2.125S1.035 7.072 1.53 6",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558q.135-.728.308-1.458s.102-.487.38-1.208",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M17.358 11.622v.405-.666h13.275l-.016 9.446c.11 3.797-2.256 6.154-6.611 7.216-3.092-.768-6.658-2.356-6.664-7.108z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M29.965 12.027H18.023l-.014 8.887c.004 3.607 2.072 5.413 5.998 6.422 4.067-1.034 6.04-3.183 5.943-6.53z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M29.89 22H18.08a8 8 0 0 1-.071-1.086l.014-8.887h11.942l-.015 8.779q.018.624-.06 1.194",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      d: "m23.517 13.877-.016-1.037.82.008.008 1.03h2.243l.008.803-2.25.008-.019 9.482-.8.005-.01-9.495-2.235.008v-.82z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      d: "m21.701 21.94 2.054 2.13c.71-.781.217-3.698-.717-4.235-.112.345-.302.76-.504.893-.445.303-1.536.658-1.172.885.084-.115.301-.224.403.032.122.403-.454.429-.454.429s-.364-.045-.428-.416.543-.71.595-.736c.05-.019.844-.23.978-.934.166-.69.34-.588.371-.6 1.036.101 1.714 1.956 1.753 3.261s-.531 2.169-.633 2.226c-.103.058-2.47-2.808-2.47-2.808z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFE1CF",
      d: "M24.407 25.007c-.054-.029-.31-.147-.364-.2-.075.09-.158.292-.229.32.095.116.444.074.593-.12m1.405-.292c.014.05-.01.067-.023.095a2 2 0 0 0-.16.515c-.006.074-.057.145-.08.19-.027.048-.02.094.043.131.113.068.56-.177.56-.27a.2.2 0 0 1 .026-.073.2.2 0 0 0 .017-.102.4.4 0 0 1 .055-.164c.032-.053.087-.146.064-.234-.022-.082-.063-.14-.094-.259-.074-.078-.176-.186-.28-.193-.106-.007-.167.065-.204.088.02.075.063.225.076.276"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      d: "M24.64 15.685a.7.7 0 0 0 .295-.02c.089-.027.526-.081.705-.02.061.006.142.04.267.145s.309.288.248.796-.041.726-.068 1.01c-.047.5-.159.914-.359.88.271.474.298.88.474 1.206s.285.989.217 1.707-.257 2.33.311 3.414c-.094.068-.325 0-.528-.217-.203-.216-.292-.21-.46-.081-.515.393-.997.867-1.707.393-.163-.108-.215-.238-.095-.57.298-.825.443-1.96.396-2.492v-5.968c.142-.122.215-.196.304-.183"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFE1CF",
      d: "M24.824 15.36a.56.56 0 0 1-.004.4.54.54 0 0 0 .027.494c.163-.23.393-.183.529-.318.135-.136.162-.264.264-.291-.102-.088-.257-.183-.224-.44.034-.258.393-.468.068-.861a.477.477 0 0 0-.647-.085.5.5 0 0 0-.135.156c-.02.044.005.144-.044.203a.7.7 0 0 1-.122.115c-.03.022-.05.055-.017.092.013.015.037.018.063.027a.5.5 0 0 1-.05.083c-.016.02-.009.04.01.057-.025.081.024.09-.01.151-.029.053-.069.115.041.176.03.017.175.05.25.041m-1.317 1.348c-.19.048-.494-.034-.725-.007-.102.012-.183-.04-.17-.142.014-.102.028-.257.007-.4-.031-.221.075-.528.224-.867s.224-.528.224-.687c0-.105.01-.224.105-.285.07-.045.083-.088.108-.125.058-.085.112-.105.119-.054.004.03-.007.057-.034.098.06-.05.164-.11.188-.127s.144-.102.15-.022q.073-.035.092.003c.013.028.005.04-.019.06.034-.007.073.052.005.105.036-.012.071.047.009.101-.065.056-.14.095-.163.14a.9.9 0 0 1-.249.194c-.064.027-.067.064-.067.16 0 1.042-.126.957-.126 1.208 0 .068-.013.129.054.109.068-.02.166-.051.268-.051zm.04 2.249c.307-.153.657-.21.84-.257s.475-.19.617-.264.257-.177.338-.204a.38.38 0 0 0 .224-.183c.264-.514.407-.927.407-1.287 0-.237-.061-.5-.292-.311-.216.178-.452.522-.515.772-.094.38-.176.46-.196.535s-.097.075-.19.095c-.4.088-.494.149-.792.372a8 8 0 0 1-.84.542c-.217.122-.257.136-.305.234a1 1 0 0 1-.132.217.17.17 0 0 0-.044.149c.007.044-.014.247-.017.315s.013.085.04.088.065-.01.079-.091c-.014.08.098.054.104-.007-.003.088.116.037.122-.044 0 .057.09.017.099-.01.02-.068.037-.143.064-.197.04-.078.082-.18.16-.237.087-.064.046-.135.23-.227"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#AA3751",
      d: "M24.773 14.317c.037-.24.207-.235.315-.21.044.01.152.02.254-.007.2-.053.352.017.332.21.054.04.111.136.101.217s.007.115.082.125c.074.01.233.102.128.23.102.062.18.217.126.322s-.217.122-.285.027c-.074.034-.196.041-.27-.037-.052.061-.18.054-.204 0a.17.17 0 0 0-.112-.098c-.054-.017-.057-.166.024-.183-.01-.044-.007-.095.014-.119.02-.023.003-.067-.044-.104-.048-.038-.089-.18-.041-.258-.081.027-.261-.05-.298-.105-.038-.054-.088-.057-.122-.01"
    }
  )
);
var SvgFlagMsr = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMsr_default = SvgFlagMsr;

export { FlagMsr_default as default };
